import React from 'react';
import '../styles/GameRules.css';

interface GameRulesProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function GameRules({ isOpen, onClose }: GameRulesProps) {
  if (!isOpen) return null;

  return (
    <div className="game-rules-overlay" onClick={onClose}>
      <div className="game-rules-container nes-container" onClick={e => e.stopPropagation()}>
        <button className="close-button nes-btn" onClick={onClose}>×</button>
        
        <div className="game-rules-content">
          <div className="game-rules-section">
            <h2>🎮 Game Mechanics</h2>
            <ul className="game-rules-list">
              <li>The game runs globally, with all players participating simultaneously in each round</li>
              <li>Each round starts with a bounty wallet funded by BreakMe.ai™ with a predetermined balance</li>
              <li>Attempt prices increase globally according to a round-specific schedule</li>
              <li>A round continues until a player successfully convinces the AI Agent to transfer the bounty to their in-game wallet</li>
              <li>When a player succeeds, the current round ends globally, and players await the next round</li>
            </ul>
          </div>

          <div className="game-rules-section">
            <h2>📜 Additional Rules</h2>
            <ul className="game-rules-list">
              <li>Players with unused attempts when a round ends can carry them over to the next round</li>
              <li>Winners have 90 days to transfer funds from their in-game wallet - after this period, unclaimed amounts return to the bounty pot</li>
              <li>Player attempts and AI responses are publicly viewable on the website in real-time - catch them before they scroll away!</li>
            </ul>
          </div>

          <div className="game-rules-section">
            <h2>💡 Strategy Tips</h2>
            <ul className="game-rules-list">
              <li>Study successful attempts to understand effective strategies</li>
              <li>Be creative and think outside the box when interacting with the AI</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
} 